import createCookie from "./createCookie";

export default function eraseCookie(name) {
  createCookie(name, "", -1);
}
